import React, { useEffect, useState } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import { Document } from "@tiptap/extension-document";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Text } from "@tiptap/extension-text";
import { Bold } from "@tiptap/extension-bold";
import { Italic } from "@tiptap/extension-italic";
import { Underline } from "@tiptap/extension-underline";
import CharacterCount from "@tiptap/extension-character-count";
import "./RichTextCell.css";

const RichTextCell = ({ value, onReady, onChange }) => {
  const [charCount, setCharCount] = useState(0);

  const editor = useEditor({
    extensions: [
      Document.extend({
        content: "block+",
      }),
      Paragraph.extend({
        content: "inline*",
      }),
      Text,
      Bold,
      Italic,
      Underline,
      CharacterCount.configure({
        limit: 100,
      }),
    ],
    content: value || "",
    editorProps: {
      handleKeyDown: (view, event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          typeof onChange === "function" && onChange();
          return true; // block Enter
        }

        const count = editor?.storage.characterCount.characters() || 0;
        if (count >= 100 && !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(event.key)) {
          event.preventDefault();
          return true;
        }
      },
      handlePaste: (view, event) => {
        const text = event.clipboardData
          .getData("text/plain")
          .replace(/\n/g, " ");
        const existingChars = editor?.storage.characterCount.characters() || 0;
        const allowed = 100 - existingChars;
        if (allowed <= 0) {
          event.preventDefault();
          return true;
        }
        editor.commands.insertContent(text.slice(0, allowed));
        return true;
      },
    },
    onUpdate: ({ editor }) => {
      setCharCount(editor.storage.characterCount.characters());
    },
  });

  // Pass editor instance up
  useEffect(() => {
    if (editor && onReady) {
      onReady(editor);
      setCharCount(editor.storage.characterCount.characters());
    }
  }, [editor, onReady]);

  if (!editor) return null;

  return (
    <div className="cell-editor-outer">
      <div className="border rounded border-black p-2 w-100" style={{ minHeight: 40 }}>
        <EditorContent editor={editor} />
      </div>
      <small className={`text-${charCount >= 90 ? "danger" : "muted"}`}>
        {charCount}/100
      </small>
    </div>
  );
};

export default RichTextCell;
